<template>
	<div
		id="content"
		class="container-fluid"
	>
		<trynow-section
			title="Develop a Career in FinTech and Publishing"
			subtitle="CAREERS"
			image="/images/top-features-img1.jpg"
			description="If you’re passionate about finance and ready to share your enthusiasm with others while having opportunities for growth — let’s have a conversation about your career today."
			btn-text="View Open Positions"
			link="#careers-open-situations"
		/>

		<div class="">
			<div class="px-8 md:px-20">
				<div
					class="mx-auto max-w-7xl py-24 sm:py-32 lg:py-32 md:flex md:items-center md:gap-x-10 lg:gap-x-20"
				>
					<div class="md:flex-1">
						<div class="text-center md:text-left">
							<div class="">
								<img
									class="mx-auto md:mx-0 mb-4 text-white"
									src="/images/top-features-icon1.svg"
									alt="Top Features Icon"
								/>
							</div>
							<h3 class="text-xl lg:text-2xl font-bold text-white mb-4 font-sauce-500">
								Our team drives our success.
							</h3>
							<p class="text-lg leading-8 text-white">
								We hire individuals who are driven to perform at a high level and excel
								in their field. We work as a team to achieve goals, complete projects,
								and celebrate our wins.
							</p>
						</div>
					</div>
					<div class="md:flex-1 mt-16 sm:mt-24 lg:mt-0 hidden md:block">
						<img
							src="/images/shutterstock_2129309294-min.jpg"
							alt="App screenshot"
							class="mx-auto max-w-full drop-shadow-xl rounded-[20px]"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="">
			<div class="px-8 md:px-20">
				<div
					class="mx-auto max-w-7xl py-24 sm:py-32 lg:py-32 md:flex md:items-center md:gap-x-10 lg:gap-x-20 flex-row-reverse"
				>
					<div class="md:flex-1">
						<div class="text-center md:text-left">
							<div class="">
								<img
									class="mx-auto md:mx-0 mb-4 text-white"
									src="/images/top-features-icon2.svg"
									alt="Top Features Icon"
								/>
							</div>
							<h3 class="text-xl lg:text-2xl font-bold text-white mb-4 font-sauce-500">
								Work from anywhere!
							</h3>
							<p class="text-lg leading-8 text-white">
								Forget spending a fortune on relocating and uprooting your life — you
								can work with us from anywhere! We have employees located across the
								country, and even outside of the country. Join our diverse and inclusive
								team as we collaborate on projects and have open conversations all from
								the comfort of your own home.
							</p>
						</div>
					</div>
					<div class="md:flex-1 mt-16 sm:mt-24 lg:mt-0 hidden md:block">
						<img
							src="/images/shutterstock_1919883236-min.jpg"
							alt="App screenshot"
							class="mx-auto max-w-full drop-shadow-xl rounded-[20px]"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="">
			<div class="px-8 md:px-20">
				<div
					class="mx-auto max-w-7xl py-24 sm:py-32 lg:py-32 md:flex md:items-center md:gap-x-10 lg:gap-x-20"
				>
					<div class="md:flex-1">
						<div class="text-center md:text-left">
							<div class="">
								<img
									class="mx-auto md:mx-0 mb-4 text-white"
									src="/images/top-features-icon3.svg"
									alt="Top Features Icon"
								/>
							</div>
							<h3 class="text-xl lg:text-2xl font-bold text-white mb-4 font-sauce-500">
								Common values and goals.
							</h3>
							<p class="text-lg leading-8 text-white">
								We're a diverse and inclusive group that values opinions, insights, and
								ideas from all of our team members. We understand that everyone has a
								unique perspective and background that can help us all reach our
								collaborative goals.
							</p>
							<br />
							<h3 class="text-xl lg:text-2xl font-bold text-white mb-4 font-sauce-500">
								Perks.
							</h3>
							<p class="text-lg leading-8 text-white">
								We offer competitive wages, health insurance, and a 401k, all with the
								ability to work from anywhere.
							</p>
						</div>
					</div>
					<div class="md:flex-1 mt-16 sm:mt-24 lg:mt-0 hidden md:block">
						<img
							src="/images/shutterstock_362816681-min.jpg"
							alt="App screenshot"
							class="mx-auto max-w-full drop-shadow-xl rounded-[20px]"
						/>
					</div>
				</div>
			</div>
		</div>

		<!-- <open-positions-section id="careers-open-situations" /> -->

		<div
			id="careers-open-situations"
			class="px-8 md:px-20"
		>
			<div class="mx-auto max-w-7xl py-8 bg-white rounded-xl">
				<div
					id="rr-job-board"
					data-job-board-id="stockstotradecom-inc"
				></div>
			</div>
		</div>

		<div class="">
			<div class="px-8 md:px-20 bg">
				<div
					class="mx-auto max-w-7xl py-24 sm:py-32 lg:py-32 md:flex md:items-center md:gap-x-10 lg:gap-x-20"
				>
					<div class="md:flex-1 bg-white/5 rounded-[20px] p-12">
						<div class="text-center md:text-left">
							<div class=""></div>

							<p class="text-lg leading-8 text-white">
								StocksToTrade is an equal opportunity employer and is committed to
								diversity and inclusion in the workplace. We prohibit discrimination and
								harassment of any kind based on race, color, gender, religion, sexual
								orientation, national origin, age, disability, veteran status, genetic
								information, pregnancy, or any other protected characteristic as
								outlined by federal, state, or local laws.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
const config = useRuntimeConfig().public;

const canonicalUrl = config.current_hostname.slice(0, -1) + "/careers/";

useHead({
	title: "StocksToTrade | Careers",
	meta: [
		{
			name: "description",
			content:
				"StocksToTrade have built-in proprietary algorithms and scanners to quickly uncover big potential opportunities happening at this moment."
		},
		{ property: "og:url", content: canonicalUrl }
	],
	link: [{ rel: "canonical", href: canonicalUrl }]
});

onMounted(() => {
	if (import.meta.client) {
		const script = document.createElement("script");
		script.src =
			"https://static-assets.ripplingcdn.com/ats/embeds/job-board.v1.js";
		script.async = true;
		document
			.getElementById("rr-job-board")
			?.insertAdjacentElement("afterend", script);
	}
});
</script>

<style lang="scss" scoped></style>
